import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Building2, Users, DollarSign, TrendingUp, Eye, Edit, Mail, Phone, MapPin, Calendar, CheckCircle, Package, Truck, BarChart3 } from 'lucide-react';
export function AgregatorManagement() {
  const agregators = [{
    id: 'AGR-001',
    name: 'PTX (PT Perdagangan Terpadu X)',
    plan: 'Enterprise',
    status: 'active',
    joinDate: 'Jan 2023',
    subscriptionFee: 25000000,
    cooperatives: 127,
    totalOrders: 12000,
    gmv: 1200000000,
    platformRevenue: 59200000,
    contact: {
      email: 'admin@ptx.co.id',
      phone: '+62 21-5555-8888',
      address: 'Jakarta Selatan'
    },
    performance: {
      uptime: 99.8,
      satisfaction: 4.7,
      onTimeDelivery: 94
    }
  }];
  return <div className="space-y-6" data-id="element-2864">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-2865">
        <div data-id="element-2866">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-2867">
            Agregator Management
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-2868">
            Kelola partner agregator dan monitoring performa
          </p>
        </div>
        <Button variant="primary" icon={<Building2 className="w-4 h-4" data-id="element-2870" />} data-id="element-2869">
          Tambah Agregator
        </Button>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-4 gap-4" data-id="element-2871">
        <Card className="p-4 border-l-4 border-l-blue-500" data-id="element-2872">
          <div className="flex items-center gap-3 mb-2" data-id="element-2873">
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-2874">
              <Building2 className="w-5 h-5 text-blue-600" data-id="element-2875" />
            </div>
          </div>
          <p className="text-sm text-slate-600 mb-1" data-id="element-2876">Total Agregator</p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-2877">1</p>
        </Card>

        <Card className="p-4 border-l-4 border-l-green-500" data-id="element-2878">
          <div className="flex items-center gap-3 mb-2" data-id="element-2879">
            <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-2880">
              <CheckCircle className="w-5 h-5 text-green-600" data-id="element-2881" />
            </div>
          </div>
          <p className="text-sm text-slate-600 mb-1" data-id="element-2882">Active</p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-2883">1</p>
        </Card>

        <Card className="p-4 border-l-4 border-l-violet-500" data-id="element-2884">
          <div className="flex items-center gap-3 mb-2" data-id="element-2885">
            <div className="w-10 h-10 bg-violet-100 rounded-lg flex items-center justify-center" data-id="element-2886">
              <DollarSign className="w-5 h-5 text-violet-600" data-id="element-2887" />
            </div>
          </div>
          <p className="text-sm text-slate-600 mb-1" data-id="element-2888">MRR Total</p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-2889">Rp 25Jt</p>
        </Card>

        <Card className="p-4 border-l-4 border-l-amber-500" data-id="element-2890">
          <div className="flex items-center gap-3 mb-2" data-id="element-2891">
            <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center" data-id="element-2892">
              <Users className="w-5 h-5 text-amber-600" data-id="element-2893" />
            </div>
          </div>
          <p className="text-sm text-slate-600 mb-1" data-id="element-2894">Total Koperasi</p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-2895">127</p>
        </Card>
      </div>

      {/* Agregator List */}
      {agregators.map(agr => <Card key={agr.id} className="p-6" data-id="element-2896">
          <div className="flex items-start gap-6 mb-6" data-id="element-2897">
            <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center text-white font-bold text-2xl shadow-lg" data-id="element-2898">
              PTX
            </div>
            <div className="flex-1" data-id="element-2899">
              <div className="flex items-start justify-between mb-3" data-id="element-2900">
                <div data-id="element-2901">
                  <div className="flex items-center gap-3 mb-2" data-id="element-2902">
                    <h3 className="text-2xl font-bold text-slate-900" data-id="element-2903">
                      {agr.name}
                    </h3>
                    <Badge variant="success" data-id="element-2904">Active</Badge>
                    <Badge className="bg-violet-100 text-violet-700" data-id="element-2905">
                      {agr.plan}
                    </Badge>
                  </div>
                  <div className="flex items-center gap-4 text-sm text-slate-600" data-id="element-2906">
                    <div className="flex items-center gap-1" data-id="element-2907">
                      <Calendar className="w-4 h-4" data-id="element-2908" />
                      <span data-id="element-2909">Member sejak {agr.joinDate}</span>
                    </div>
                    <span className="text-slate-400" data-id="element-2910">•</span>
                    <span className="font-mono" data-id="element-2911">{agr.id}</span>
                  </div>
                </div>
                <div className="flex gap-2" data-id="element-2912">
                  <Button variant="outline" size="sm" icon={<Eye className="w-4 h-4" data-id="element-2914" />} data-id="element-2913">
                    Detail
                  </Button>
                  <Button variant="outline" size="sm" icon={<Edit className="w-4 h-4" data-id="element-2916" />} data-id="element-2915">
                    Edit
                  </Button>
                </div>
              </div>

              {/* Contact Info */}
              <div className="flex items-center gap-6 text-sm mb-4" data-id="element-2917">
                <div className="flex items-center gap-2" data-id="element-2918">
                  <Mail className="w-4 h-4 text-slate-400" data-id="element-2919" />
                  <span className="text-slate-600" data-id="element-2920">{agr.contact.email}</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-2921">
                  <Phone className="w-4 h-4 text-slate-400" data-id="element-2922" />
                  <span className="text-slate-600" data-id="element-2923">{agr.contact.phone}</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-2924">
                  <MapPin className="w-4 h-4 text-slate-400" data-id="element-2925" />
                  <span className="text-slate-600" data-id="element-2926">{agr.contact.address}</span>
                </div>
              </div>

              {/* Metrics Grid */}
              <div className="grid grid-cols-6 gap-4" data-id="element-2927">
                <div className="p-3 bg-green-50 rounded-lg border border-green-200" data-id="element-2928">
                  <p className="text-xs text-green-700 mb-1" data-id="element-2929">Subscription</p>
                  <p className="text-lg font-bold text-green-900" data-id="element-2930">
                    Rp {(agr.subscriptionFee / 1000000).toFixed(0)}Jt
                  </p>
                  <p className="text-xs text-green-600 mt-1" data-id="element-2931">/bulan</p>
                </div>

                <div className="p-3 bg-blue-50 rounded-lg border border-blue-200" data-id="element-2932">
                  <p className="text-xs text-blue-700 mb-1" data-id="element-2933">Koperasi</p>
                  <p className="text-lg font-bold text-blue-900" data-id="element-2934">
                    {agr.cooperatives}
                  </p>
                  <p className="text-xs text-blue-600 mt-1" data-id="element-2935">aktif</p>
                </div>

                <div className="p-3 bg-violet-50 rounded-lg border border-violet-200" data-id="element-2936">
                  <p className="text-xs text-violet-700 mb-1" data-id="element-2937">Total Orders</p>
                  <p className="text-lg font-bold text-violet-900" data-id="element-2938">
                    {(agr.totalOrders / 1000).toFixed(1)}K
                  </p>
                  <p className="text-xs text-violet-600 mt-1" data-id="element-2939">bulan ini</p>
                </div>

                <div className="p-3 bg-amber-50 rounded-lg border border-amber-200" data-id="element-2940">
                  <p className="text-xs text-amber-700 mb-1" data-id="element-2941">GMV</p>
                  <p className="text-lg font-bold text-amber-900" data-id="element-2942">
                    Rp {(agr.gmv / 1000000000).toFixed(1)}M
                  </p>
                  <p className="text-xs text-amber-600 mt-1" data-id="element-2943">bulan ini</p>
                </div>

                <div className="p-3 bg-slate-50 rounded-lg border border-slate-200" data-id="element-2944">
                  <p className="text-xs text-slate-700 mb-1" data-id="element-2945">Platform Rev</p>
                  <p className="text-lg font-bold text-slate-900" data-id="element-2946">
                    Rp {(agr.platformRevenue / 1000000).toFixed(1)}Jt
                  </p>
                  <p className="text-xs text-slate-600 mt-1" data-id="element-2947">bulan ini</p>
                </div>

                <div className="p-3 bg-green-50 rounded-lg border border-green-200" data-id="element-2948">
                  <p className="text-xs text-green-700 mb-1" data-id="element-2949">On-Time</p>
                  <p className="text-lg font-bold text-green-900" data-id="element-2950">
                    {agr.performance.onTimeDelivery}%
                  </p>
                  <p className="text-xs text-green-600 mt-1" data-id="element-2951">delivery</p>
                </div>
              </div>
            </div>
          </div>

          {/* Performance Indicators */}
          <div className="pt-4 border-t border-slate-200" data-id="element-2952">
            <h4 className="text-sm font-bold text-slate-700 mb-3" data-id="element-2953">
              Performance Indicators
            </h4>
            <div className="grid grid-cols-3 gap-4" data-id="element-2954">
              <div data-id="element-2955">
                <div className="flex justify-between items-center mb-2" data-id="element-2956">
                  <span className="text-sm text-slate-600" data-id="element-2957">System Uptime</span>
                  <span className="text-sm font-bold text-green-600" data-id="element-2958">
                    {agr.performance.uptime}%
                  </span>
                </div>
                <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-2959">
                  <div className="h-full bg-green-500 rounded-full" style={{
                width: `${agr.performance.uptime}%`
              }} data-id="element-2960"></div>
                </div>
              </div>

              <div data-id="element-2961">
                <div className="flex justify-between items-center mb-2" data-id="element-2962">
                  <span className="text-sm text-slate-600" data-id="element-2963">
                    Customer Satisfaction
                  </span>
                  <span className="text-sm font-bold text-blue-600" data-id="element-2964">
                    {agr.performance.satisfaction}/5.0
                  </span>
                </div>
                <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-2965">
                  <div className="h-full bg-blue-500 rounded-full" style={{
                width: `${agr.performance.satisfaction / 5 * 100}%`
              }} data-id="element-2966"></div>
                </div>
              </div>

              <div data-id="element-2967">
                <div className="flex justify-between items-center mb-2" data-id="element-2968">
                  <span className="text-sm text-slate-600" data-id="element-2969">
                    On-Time Delivery
                  </span>
                  <span className="text-sm font-bold text-violet-600" data-id="element-2970">
                    {agr.performance.onTimeDelivery}%
                  </span>
                </div>
                <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-2971">
                  <div className="h-full bg-violet-500 rounded-full" style={{
                width: `${agr.performance.onTimeDelivery}%`
              }} data-id="element-2972"></div>
                </div>
              </div>
            </div>
          </div>
        </Card>)}
    </div>;
}